import { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import '../css/AgGridStyles.css';
import { TablePagination } from '@material-ui/core';
import { PageContext } from '../PageContext';
import { getAgGridOptions } from '../../../../common/grid/AgGridOptions';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    overlayContainer: {
        position: "relative",
        height: "100%",
    },
    overlay: {
        position: "absolute",
        top: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        opacity: ".7"
    }
}));

export const LogsGrid = ({
    dataSource,
    disabled,
    onLoadMore,
    ...props }) => {
    const classes = useStyles();

    const {
        state,
        isBusy,
        setGridApi,
        setGridColumnApi
    } = useContext(PageContext);

    const {
        table
    } = state;

    const [gridOptions, setGridOptions] = useState(
        getAgGridOptions(
            table,
            {
                showColumnTypes: false,
                editable: false,
                columnDefs: [
                    { field: "ActionDate", flex: 1, headerName: "Action Date" },
                    { field: "TableName", flex: 2, headerName: "Table" },
                    { field: "UserDisplayName", flex: 2, headerName: "User" },
                    { field: "ActionMessage", flex: 3, headerName: "Action" }
                ]
            }
        )
    );

    const agGridReadyHandler = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    }

    const [pageIndex, setPageIndex] = useState(-1);
    const pageIndexChangeHandler = (e, index) => {
        setPageIndex(index);
    }

    const [pageSize, setPageSize] = useState(dataSource.pageSize);
    const pageSizeChangeHandler = (e) => {
        setPageSize(e.target.value)
    }

    useEffect(() => {
        if (pageIndex !== -1) {
            if (onLoadMore) onLoadMore(pageIndex, pageSize);
        }
    }, [pageIndex, pageSize]);

    return (
        <div className={clsx("ag-theme-alpine", classes.root, props.className)}>
            <div className={classes.overlayContainer}>
                <AgGridReact
                    className="ag-theme-alpine"
                    theme={'legacy'}
                    gridOptions={gridOptions}
                    serverSideDatasource={dataSource}
                    onGridReady={agGridReadyHandler}
                />
                <TablePagination
                    component="div"
                    count={dataSource ? dataSource.currentRowCount : 0}
                    onPageChange={pageIndexChangeHandler}
                    onRowsPerPageChange={pageSizeChangeHandler}
                    page={Math.max(0, pageIndex)}
                    rowsPerPage={pageSize}
                    rowsPerPageOptions={[5, 10, pageSize]}
                />
                {disabled && <div className={classes.overlay} />}
            </div>
        </div>
    );
}